import { Component, Input } from '@angular/core';
import {
  Terminal,
  TerminalAction,
} from '../../../../../../@core/domain/interfaces/terminal.interface';

@Component({
  selector: 'app-terminal-status',
  templateUrl: './terminal-status.component.html',
  styleUrls: ['./terminal-status.component.scss'],
})
export class TerminalStatusComponent {
  @Input()
  terminal!: Terminal;

  @Input()
  filteredActions!: TerminalAction[];

  @Input()
  disableToggleClick = false;

  constructor() {}

  onPreventToggleClick($event: boolean) {
    this.disableToggleClick = true;
  }
}
